<div class="date-controls"><label
  >{{ 'workforceCutover.start' | translate
  }}<input type="date" [(ngModel)]="start" (change)="load()"
/></label>
<label
  >{{ 'workforceCutover.end' | translate
  }}<input type="date" [(ngModel)]="end" (change)="load()"
/></label>
</div>
@if (error()) {
  <p role="alert">{{ 'workforceCutover.failed' | translate }}</p>
}
@if (mode() === 'plan') {
  <app-workforce-planning-panel
    [employee]="employee()"
    [selectedDate]="start"
    [shift]="selected()"
    [absence]="selectedAbsence()"
    (changed)="saved()"
  />
  @for (r of shifts(); track r.id) {
    <p class="workspace-row">
      <button (click)="selectedAbsence.set(null); selected.set(r)">
        {{ r.shift_date | date:'EEE d.M.y' }} · {{ siteName(r.firestore_site_id) }} ·
        {{ r.start_time?.slice(0,5) || '—' }}–{{ r.end_time?.slice(0,5) || '—' }} ·
        {{ 'workforceCutover.' + r.status | translate }}
      </button>
    </p>
  }
  @for (a of absences(); track a.id) {
    <p class="workspace-row">
      <button
        type="button"
        (click)="selected.set(null); selectedAbsence.set(a)"
      >
        {{ a.start_date | date:'d.M.y' }}–{{ a.end_date | date:'d.M.y' }} ·
        {{ 'workforceCutover.' + a.type | translate }}
      </button>
    </p>
  }
  <a routerLink="/users/shifts">{{
    'workforceCutover.publishPeriod' | translate
  }}</a>
} @else {
  @for (d of days(); track d.id) {
    <section class="workspace-row"><header><button (click)="openedDay.set(openedDay() === d.work_date ? '' : d.work_date)">{{ d.work_date | date:'EEE d.M.y' }}</button><span>{{ d.status === 'REVIEWED' ? 'Työnjohto tarkastanut' : 'Odottaa tarkastusta' }}</span><strong>{{ duration(minutes(d)) }} h</strong></header>
    @for(s of d.segments;track s.id){<p>{{ siteName(s.firestore_site_id) }} · {{ duration(s.minutes) }} h @if(s.start_time){ · {{s.start_time.slice(0,5)}}–{{s.end_time.slice(0,5)}} }</p>}
    @if(openedDay()===d.work_date){<app-worker-day-panel [date]="d.work_date.slice(0,10)" [worker]="employee()"/>}
    </section>
  }
  <a
    routerLink="/workforce-v2/work-days"
    [queryParams]="{ employee: employee(), start: start, end: end }"
    >{{ 'workforceCutover.openTime' | translate }}</a
  >
}
